module.exports = __webpack_public_path__ + "static/media/thumbtack.caea5fc6.glb";